module.exports = __webpack_public_path__ + "37490a6ee5001972cec23261b9042859.fbx";